import React from 'react';
import { motion } from 'framer-motion';
export function WillpowerSection() {
  return <section className="w-full bg-white py-14 px-4 md:px-8" data-id="element-264">
      <div className="max-w-2xl mx-auto text-center" data-id="element-265">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-266">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark mb-6" data-id="element-267">
            El problema no es{' '}
            <span className="text-highlight" data-id="element-268">falta de voluntad</span>
          </h2>

          <p className="text-primary-mid leading-relaxed mb-4" data-id="element-269">
            La mayoría de mujeres cree que el problema es "comer mal".
          </p>

          <p className="text-primary-mid leading-relaxed mb-6" data-id="element-270">
            Pero muchas veces la inflamación viene de hábitos, alimentos y
            desbalances que nadie te enseñó a identificar.
          </p>

          <div className="bg-bg-soft border-l-4 border-highlight p-5 rounded-xl text-left" data-id="element-271">
            <p className="text-text-dark font-semibold" data-id="element-272">
              👉 Hasta que no corregís la causa real, la hinchazón vuelve una y
              otra vez.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}